<template>
  <v-card class="common-card-log">
    <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12" class="px-0">
      <div class="pric_content_sidbar">
        <h6 class="font-weight-bold mainFont--text">جمع مبلغ کالاها:</h6>
        <h6 class="font-weight-bold mainFont--text">
          {{ Number(finalPrice).toLocaleString() }} تومان
        </h6>
      </div>
      <div class="pric_content_sidbar">
        <h6 class="font-weight-bold mainFont--text">
          جمع مبلغ کالاها با تخفیف:
        </h6>
        <h6 class="font-weight-bold mainFont--text">
          {{ Number(finalDiscountPrice).toLocaleString() }} تومان
        </h6>
      </div>
      <div class="pric_content_sidbar">
        <h6 class="font-weight-bold mainFont--text">جمع مبلغ تخفیف:</h6>
        <h6 class="font-weight-bold mainFont--text">
          {{ Number(finalDiscount).toLocaleString() }} تومان
        </h6>
      </div>
    </v-col>
    <!-- <v-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
      <div class="text-content-sideBar">
        <h5 class="fs-medium font-weight-bold mainFont--text">کد تخفیف:</h5>
        <h4 class="fs-medium mainFont--text">
          اگر کد تخفیف دارید اینجا وارد کنید
        </h4>
      </div>
    </v-col> -->
    <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12" class="px-0">
      <div class="custom-input custom-input-cart mt-3">
        <!-- <div class="d-flex">
      <v-text-field
        light
        v-model="discount"
        background-color="white"
        rounded
        dense
        outlined
      ></v-text-field>
<v-btn @click="discountValidate" color="primary">بررسی</v-btn>
    </div> -->
        <h3 class="font-weight-bold mainFont--text">
          هزینه ارسال در ادامه بر اساس آدرس و نحوه‌ی ارسال محاسبه و اضافه خواهد
          شد.
        </h3>
      </div>
    </v-col>

    <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12" class="px-0">
      <div>
        <v-btn height="44" block class="purple-mainBtn" @click="onClick"
          >تکمیل فرایند خرید</v-btn
        >
      </div>
    </v-col>
  </v-card>
</template>
<script>
import Axios from "axios";

export default {
  name: "SidBarInfo",
  props: ["info", "onClick"],

  data: () => ({
    discount: "",
    cart: [],
    cartId: "",
    checkoutCart: [],
  }),
  methods: {
    discountValidate() {
      Axios.post(
        this.baseUrl + "/onlineShop/discount/validate",
        {
          discount: this.discount,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("success", "success");
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    // discount(){
    //   '/discount/validate',{
    //     'discount':
    //   }
    // }
  },

  mounted() {
    this.cartId = localStorage.getItem("cartId");
    this.cart = localStorage.getItem("cart")
      ? localStorage.getItem("cart")
      : [];
  },
  computed: {
    finalPrice() {
      let totalCost;
      if (this.info) {
        totalCost = this.info
          .map((item) => item.price * item.amount)
          .reduce((a, b) => a + b, 0);
      }
      return totalCost;
    },
    finalDiscountPrice() {
      let totalCost;
      if (this.info) {
        totalCost = this.info
          .map((item) => item.specialPrice * item.amount)
          .reduce((a, b) => a + b, 0);
      }
      return totalCost;
    },
    finalDiscount() {
      let totalCost;
      if (this.info) {
        totalCost = this.info
          .map((item) => (item.price - item.specialPrice) * item.amount)
          .reduce((a, b) => a + b, 0);
      }
      return totalCost;
    },
  },
};
</script>
<style lang="scss">
.custom-input-cart {
  h3 {
    font-size: 14px;
    @media only screen and (min-width: 768px) {
      font-size: 13px;
    }
  }
  .v-input__slot {
    width: 100% !important;
  }
  .v-text-field .v-input__control,
  .v-text-field fieldset {
    border-radius: 8px !important;
    min-height: 35px !important;
  }
}
.sidBarInfo {
  background: #fff;
  border-radius: 8px;
  padding: 15px 20px;
}

.content_sidBarInfo {
  display: flex;
  justify-content: center;
}

.img_content_sidBarInfo {
  height: 80px;
  width: 60px;

  img {
    width: 100%;
    height: 100%;
  }
}

.pric_content_sidbar {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;

  h6 {
    font-size: 14px;
  }
}

.text-content-sideBar {
  h4,
  h5 {
    font-size: 18px;
    font-weight: 600;
    color: var(--mainFont);
  }

  h4 {
    font-size: 16px;
    font-weight: 500;
  }
}

.discount_content_sidBarInfo {
  .v-text-field {
    width: 100%;

    .v-input__control {
      display: flex;
      justify-content: center;
      color: #000;
      border-radius: 16px;
      border: 2px solid var(--deep-purple-accent4);
      overflow: hidden;
      width: 100%;
      height: 48px;
      box-shadow: none !important;
    }

    .v-field--variant-solo {
      box-shadow: none !important;
      border: none !important;
      width: 100%;
    }
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: var(--mainFont);
  }
}

.line-content_sidBarInfo {
  border: 2px dashed var(--deep-purple-accent4);
  margin: 30px 0;
}

@media only screen and (max-width: 1280px) and (max-width: 1024px) {
  .discount_content_sidBarInfo {
    h3 {
      text-align: center;
      font-size: 16px;
    }
  }
}

@media only screen and (min-width: 1024px) {


  .text-content-sideBar {
    h4,
    h5 {
      font-size: 16px;
    }
  }
}

@media only screen and (min-width: 768px) {
  .discount_content_sidBarInfo {
    h3 {
      text-align: center;
      font-size: 15px;
    }
  }
}
</style>
